import { cva, type VariantProps } from "class-variance-authority";
import React from "react";

const scoreBadgeVariants = cva("", {
  variants: {
    variant: {
      "score-lg": "font-sans text-3xl font-bold sm:text-4xl",
      "score-sm": "font-sans text-2xl font-bold sm:text-3xl",
      "stat-value": "font-display text-2xl font-light md:text-3xl",
      "stat-label": "font-sans text-xs tracking-widest uppercase",
    },
    tone: {
      inherit: "text-inherit",
      foreground: "text-foreground",
      muted: "text-muted-foreground",
      primary: "text-primary",
      destructive: "text-destructive",
      white: "text-white",
    },
    display: {
      inline: "inline",
      block: "block",
      inlineBlock: "inline-block",
    },
  },
});

type Component = "span" | "p" | "div";

export type ScoreBadgeProps = VariantProps<typeof scoreBadgeVariants> & {
  readonly component?: Component;
  readonly text?: string | number | null;
};

export default function ScoreBadge({
  component = "span",
  text = "",
  variant,
  tone,
  display,
}: ScoreBadgeProps): React.ReactElement {
  return React.createElement(
    component,
    { className: scoreBadgeVariants({ variant, tone, display }) },
    text,
  );
}
